let paso1Data, imagenProductoBase64, imagenBoletaBase64, imagenShopifyUrl;

const ST_SPINNER = `<svg class="st-spinner-svg" viewBox="0 0 36 36" width="36" height="36" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="15" fill="none" stroke="rgba(189,45,52,0.15)" stroke-width="3"/><circle cx="18" cy="18" r="15" fill="none" stroke="#bd2d34" stroke-width="3" stroke-dasharray="24 70" stroke-linecap="round"/></svg>`;
const ST_SPINNER_SM = `<svg class="st-spinner-sm" viewBox="0 0 14 14" width="14" height="14" xmlns="http://www.w3.org/2000/svg"><circle cx="7" cy="7" r="5" fill="none" stroke="rgba(189,45,52,0.15)" stroke-width="2"/><circle cx="7" cy="7" r="5" fill="none" stroke="#bd2d34" stroke-width="2" stroke-dasharray="8 24" stroke-linecap="round"/></svg>`;

// Usar función del módulo core
function obtenerValorCampo(id) {
  return formularioCore.obtenerValorCampo(id);
}

// Usar función del módulo core
function fileToBase64(file) {
  return formularioCore.fileToBase64(file);
}

// Usar función del módulo core
function comprimirImagenSiNecesario(file, maxWidth = 800, maxHeight = 800, quality = 0.5) {
  return formularioCore.comprimirImagenSiNecesario(file, maxWidth, maxHeight, quality);
}

// Usar función del módulo core
function validarArchivo(file) {
  return formularioCore.validarArchivo(file);
}


// Usar función del módulo core
function formatearRut(rut) {
  return formularioCore.formatearRut(rut);
}

// Usar función del módulo core
function determinarGarantia(fechaCompra) {
  return formularioCore.determinarGarantia(fechaCompra);
}


function manejarCargaImagen(e, tipo) {
  const file = e.target.files[0];
  if (!file || !validarArchivo(file)) {
    e.target.value = '';
    return;
  }
  
  const previewContainer = document.getElementById(`imagen-${tipo}-preview-container`);
  const previewImg = document.getElementById(`imagen-${tipo}-preview`);
  
  previewContainer.classList.remove('hidden');
  previewImg.style.display = 'none';
  
  const loadingIndicator = document.createElement('div');
  loadingIndicator.className = 'imagen-loading-indicator';
  loadingIndicator.innerHTML = '<div class="imagen-placeholder imagen-loading"><span class="imagen-placeholder-text">Cargando...</span></div>';
  previewContainer.appendChild(loadingIndicator);
  
  comprimirImagenSiNecesario(file)
    .then(base64String => {
      // Guardar en variables globales
      if (tipo === 'producto') {
        imagenProductoBase64 = base64String;
        console.log('Imagen producto guardada, tamaño:', base64String.length);
      } else if (tipo === 'boleta') {
        imagenBoletaBase64 = base64String;
        console.log('Imagen boleta guardada, tamaño:', base64String.length);
      }
      
      loadingIndicator?.remove();
      previewImg.src = base64String;
      previewImg.style.display = 'block';
    })
    .catch(error => {
      console.error(`Error al procesar imagen:`, error);
      alert('Error al procesar la imagen.');
      loadingIndicator?.remove();
      previewContainer.classList.add('hidden');
    });
}

// Usar funciones del módulo core
function mostrarIndicadorPasos() {
  return formularioCore.mostrarIndicadorPasos();
}

function ocultarIndicadorPasos() {
  return formularioCore.ocultarIndicadorPasos();
}

function crearModalOrden() {
  if (document.getElementById('orden-modal')) return;
  
  const modalHTML = `
    <div class="orden-modal" id="orden-modal">
      <div class="orden-modal-content">
        <span class="orden-modal-close">&times;</span>
        <div class="orden-modal-header">
          <h4>¡Solicitud Enviada con Éxito!</h4>
        </div>
        <div class="orden-modal-body">
          <p>Tu solicitud ha sido recibida correctamente.</p>
          <div class="orden-numero">Número de Orden: <strong id="orden-numero-valor"></strong></div>
          <div id="pdf-link-container" class="hidden">
            <a id="pdf-link" href="#" target="_blank" class="btn-pdf">Descargar PDF</a>
          </div>
        </div>
        <div class="orden-modal-footer">
          <button class="btn-enviar" id="btn-cerrar-modal">Aceptar</button>
        </div>
      </div>
    </div>
  `;
  
  document.body.insertAdjacentHTML('beforeend', modalHTML);
}

function actualizarPasoIndicador(paso) {
  document.querySelectorAll('.paso-item').forEach(item => {
    item.classList.remove('paso-activo');
    item.classList.remove('paso-completado');
  });
  
  document.getElementById('paso-' + paso).classList.add('paso-activo');
  
  for (let i = 1; i < paso; i++) {
    document.getElementById('paso-' + i).classList.add('paso-completado');
  }
}

function mostrarModalOrden(result) {
  const modalExistente = document.getElementById('orden-modal');
  if (modalExistente) {
    modalExistente.remove();
  }
  
  crearModalOrden();
  
  document.querySelector('.orden-modal-close').addEventListener('click', cerrarModalOrden);
  document.getElementById('btn-cerrar-modal').addEventListener('click', cerrarModalOrden);
  
  let orderId, pdfUrl;
  
  if (typeof result === 'object' && result !== null) {
    orderId = result.ordenId;
    pdfUrl = result.pdfUrl;
  } else {
    orderId = result;
    pdfUrl = "";
  }
  
  document.getElementById('orden-numero-valor').textContent = orderId;
  
  const pdfLinkContainer = document.getElementById('pdf-link-container');
  const pdfLink = document.getElementById('pdf-link');
  
  if (pdfUrl && pdfUrl.includes('pdfProducto.php')) {
    pdfLinkContainer.classList.remove('hidden');
    pdfLink.href = pdfUrl;
  } else {
    pdfLinkContainer.classList.add('hidden');
    
    if (orderId && !isNaN(parseInt(orderId))) {
      const numeroPuro = orderId.toString().replace(/[^\d]/g, '');
      if (numeroPuro) {
        pdfLinkContainer.classList.remove('hidden');
        pdfLink.href = `https://ssttbeca.ines.cl/ssttbeca/pdfProducto.php?ticket=${numeroPuro}`;
      }
    }
  }
  
  const modalElement = document.getElementById('orden-modal');
  if (modalElement) {
    modalElement.style.display = 'flex';
    modalElement.style.opacity = '1';
    modalElement.style.visibility = 'visible';
    
    console.log("Modal mostrado con ID de orden:", orderId);
    console.log("URL del PDF (si existe):", pdfUrl);
  } else {
    console.error("No se pudo mostrar el modal - elemento no encontrado después de crearlo");
    alert("Orden creada exitosamente. ID: " + orderId);
  }
}
function cerrarModalOrden() {
  const modal = document.getElementById('orden-modal');
  if (modal) {
    modal.style.display = 'none';
  }
}

function resetearFormularios() {
  document.getElementById('formulario-reparacion').reset();
  document.getElementById('formulario-datos-cliente').reset();
  
  document.getElementById('formulario-reparacion').classList.add('hidden');
  document.getElementById('formulario-datos-cliente').classList.add('hidden');
  document.getElementById('resultado-consulta').classList.add('hidden');
  
  document.getElementById('consulta-reparacion').value = '';
  
  ocultarIndicadorPasos();
  
  paso1Data = {};
  imagenProductoBase64 = '';
  imagenBoletaBase64 = '';
  imagenShopifyUrl = '';
  
  document.getElementById('producto-imagen-container').classList.add('hidden');
  document.getElementById('detalles-producto').classList.add('hidden');
  document.getElementById('producto-imagen').src = '';
  document.getElementById('marca-valor').textContent = 'Cargando...';
  document.getElementById('id-prod-valor').textContent = 'Cargando...';
  
  const productoPreviewContainer = document.getElementById('imagen-producto-preview-container');
  if (productoPreviewContainer) productoPreviewContainer.classList.add('hidden');
  
  const boletaPreviewContainer = document.getElementById('imagen-boleta-preview-container');
  if (boletaPreviewContainer) boletaPreviewContainer.classList.add('hidden');
  
  const placeholders = document.querySelectorAll('.imagen-placeholder');
  placeholders.forEach(placeholder => placeholder.remove());
}

function limitarFechaCompra() {
  const fechaCompraInput = document.getElementById('fecha-compra');
  if (fechaCompraInput) {
    const hoy = new Date().toISOString().split('T')[0];
    fechaCompraInput.setAttribute('max', hoy);
  }
}

function inicializarPlaceholdersImagen() {
  document.querySelectorAll('.producto-imagen-container').forEach(container => {
    if (!container.classList.contains('hidden')) {
      const img = container.querySelector('img');
      
      if (!img || img.style.display === 'none') {
        const placeholderExists = container.querySelector('.imagen-placeholder');
        
        if (!placeholderExists) {
          const placeholder = document.createElement('div');
          placeholder.className = 'imagen-placeholder';
          placeholder.innerHTML = `
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 16L8.586 11.414C8.96106 11.0391 9.46967 10.8284 10 10.8284C10.5303 10.8284 11.0389 11.0391 11.414 11.414L16 16M14 14L15.586 12.414C15.9611 12.0391 16.4697 11.8284 17 11.8284C17.5303 11.8284 18.0389 12.0391 18.414 12.414L20 14M14 8H14.01M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="imagen-placeholder-text">Sin imagen</span>
          `;
          container.appendChild(placeholder);
        }
      } else {
        const placeholderExists = container.querySelector('.imagen-placeholder');
        if (placeholderExists) {
          placeholderExists.remove();
        }
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Inicializar variables globales desde el módulo core
  paso1Data = formularioCore.paso1Data;
  imagenProductoBase64 = formularioCore.imagenProductoBase64;
  imagenBoletaBase64 = formularioCore.imagenBoletaBase64;
  imagenShopifyUrl = formularioCore.imagenShopifyUrl;
  
  inicializarSelectorRegiones();
  
  const categoriaSelect = document.getElementById('categoria');
  if (categoriaSelect.value) {
    categoriaSelect.dispatchEvent(new Event('change'));
  }
  
  const regionSelect = document.getElementById('region');
  if (regionSelect.value) {
    document.getElementById('comuna').disabled = false;
  }
  
  const camposRequeridos = document.querySelectorAll('[required]');
  camposRequeridos.forEach(campo => {
    campo.removeAttribute('required');
  });
  
  document.getElementById('resultado-consulta').innerHTML = `
    <h5>Estado de la Orden de Reparación</h5>
    <div class="resultado-contenido"></div>
  `;
  
  configurarEventListeners();
  
  const emailField = document.getElementById('cliente-email');
  if (emailField) {
    console.log("Campo email encontrado y configurado");
    emailField.classList.add('email-field-monitored');
  } else {
    console.error("¡ADVERTENCIA! No se encontró el campo de email al cargar la página");
  }
});

function inicializarSelectorRegiones() {
  const regionSelect = document.getElementById('region');
  regionSelect.innerHTML = '<option value="">Seleccione región...</option>';
  
  regionesChile.regiones.forEach(regionData => {
    const option = document.createElement('option');
    option.value = regionData.region;
    option.textContent = regionData.region;
    regionSelect.appendChild(option);
  });
}

function configurarEventListeners() {
  document.getElementById('btn-ingresar').addEventListener('click', function() {
    formularioCore.resetearFormularios();
    formularioCore.mostrarIndicadorPasos();
    limitarFechaCompra();
    document.getElementById('formulario-reparacion').classList.remove('hidden');
    formularioCore.actualizarPasoIndicador(1);
  });

  document.querySelector('.btn-consultar').addEventListener('click', consultarOrden);

  const inputConsulta = document.getElementById('consulta-reparacion');
  inputConsulta.addEventListener('input', () => {
    inputConsulta.value = inputConsulta.value.replace(/\D/g, '');
    inputConsulta.classList.remove('campo-invalido');
  });
  inputConsulta.addEventListener('keydown', e => { if (e.key === 'Enter') consultarOrden(); });
  
  document.getElementById('categoria').addEventListener('change', actualizarProductos);
  
  document.getElementById('producto').addEventListener('change', actualizarDetallesProducto);
  
  document.getElementById('region').addEventListener('change', actualizarComunas);
  
  document.getElementById('btn-continuar').addEventListener('click', function() {
    continuarPaso2();
    
    if (!document.getElementById('formulario-datos-cliente').classList.contains('hidden')) {
      formularioCore.actualizarPasoIndicador(2);
    }
  });
  
  document.getElementById('btn-volver').addEventListener('click', function() {
    document.getElementById('formulario-datos-cliente').classList.add('hidden');
    document.getElementById('formulario-reparacion').classList.remove('hidden');
    
    formularioCore.actualizarPasoIndicador(1);
  });
  
  document.getElementById('formulario-datos-cliente').addEventListener('submit', enviarFormulario);

  inicializarMarcaUI();
  
  const imagenProductoInput = document.getElementById('imagen-producto');
  if (imagenProductoInput) {
    imagenProductoInput.addEventListener('change', function(e) {
      manejarCargaImagen(e, 'producto');
    });
  }
  
  const imagenBoletaInput = document.getElementById('imagen-boleta');
  if (imagenBoletaInput) {
    imagenBoletaInput.addEventListener('change', function(e) {
      manejarCargaImagen(e, 'boleta');
    });
  }
  
  document.querySelectorAll('.btn-eliminar-imagen').forEach(btn => {
    btn.addEventListener('click', function() {
      const tipo = this.getAttribute('data-target');
      document.getElementById(`imagen-${tipo}`).value = '';
      document.getElementById(`imagen-${tipo}-preview-container`).classList.add('hidden');
      
      if (tipo === 'producto') {
        imagenProductoBase64 = '';
      } else if (tipo === 'boleta') {
        imagenBoletaBase64 = '';
      }
    });
  });
}

document.getElementById('btn-volver-inicio').addEventListener('click', function() {
  document.getElementById('formulario-reparacion').classList.add('hidden');
  formularioCore.ocultarIndicadorPasos();
});

async function consultarOrden() {
  const input = document.getElementById('consulta-reparacion');
  const orderNumber = input.value.trim();

  input.classList.remove('campo-invalido');

  if (!orderNumber || !/^\d+$/.test(orderNumber)) {
    input.classList.add('campo-invalido');
    input.focus();
    return;
  }

  sessionStorage.setItem('ordenIdOriginal', orderNumber);
  
  formularioCore.resetearFormularios();
  
  const consultarBtn = document.querySelector('.btn-consultar');
  consultarBtn.classList.add('loading');
  consultarBtn.disabled = true;
  
  const resultadoDiv = document.getElementById('resultado-consulta');
  resultadoDiv.classList.remove('hidden');
  resultadoDiv.innerHTML = `
    <h5>Consultando Orden...</h5>
    <div class="resultado-cargando">
      ${ST_SPINNER}
      <span class="imagen-placeholder-text">Consultando información...</span>
    </div>
  `;
  
  document.getElementById('consulta-reparacion').blur();
  
  try {
    const data = await inesAPI.consultarOrden(orderNumber);

    if (!data || Object.keys(data).length === 0) {
      mostrarErrorConsulta('not-found', orderNumber);
      return;
    }

    // Decodificar las entidades HTML en los campos de texto
    Object.keys(data).forEach(key => {
      if (typeof data[key] === 'string') {
        data[key] = formularioCore.decodeHTMLEntities(data[key]);
      }
    });

    mostrarResultadoConsulta(data);
  } catch (error) {
    console.error('Error al consultar la orden:', error);
    // TypeError = fallo de red real; otros errores = respuesta inesperada de INES
    const esErrorRed = error instanceof TypeError;
    mostrarErrorConsulta(esErrorRed ? 'error' : 'not-found', orderNumber);
  } finally {
    consultarBtn.classList.remove('loading');
    consultarBtn.disabled = false;
  }
}


function decodeHTMLEntities(text) {
  if (!text) return text;
  
  const textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
}

function mostrarErrorConsulta(tipo, orderNumber) {
  const esNotFound = tipo === 'not-found';
  const alertClass  = esNotFound ? 'alert-warning' : 'alert-danger';
  const strokeColor = esNotFound ? '#856404' : '#721c24';
  const iconPath    = esNotFound
    ? 'M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z'
    : 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z';
  const titulo  = esNotFound
    ? `No se encontró la orden <strong>${orderNumber || ''}</strong>`
    : 'No pudimos conectar con el servidor';
  const detalle = esNotFound
    ? 'Verifica que el número sea correcto e ingresa al menos 5 dígitos.'
    : 'Ocurrió un error al procesar tu consulta. Intenta nuevamente en unos momentos.';

  const resultadoDiv = document.getElementById('resultado-consulta');
  resultadoDiv.innerHTML = `
    <h5>Estado de la Orden de Reparación</h5>
    <div class="resultado-contenido">
      <div class="alert ${alertClass}">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0">
          <path d="${iconPath}" stroke="${strokeColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div>
          <p><strong>${titulo}</strong></p>
          <p style="margin-top:4px;font-size:13px;">${detalle}</p>
        </div>
      </div>
      <div class="consulta-botones" style="margin-top:20px;padding-top:16px;border-top:1px solid #e0e0e0;">
        <button type="button" class="btn-volver" onclick="formularioCore.resetearFormularios()">Volver</button>
        <button type="button" class="btn-enviar" onclick="document.getElementById('btn-ingresar').click()">Ingresar Nueva Orden</button>
      </div>
    </div>
  `;
}



function formatearPrecio(valor) {
  const numero = typeof valor === 'string' ? parseFloat(valor.replace(/[^\d.-]/g, '')) : valor;
  
  if (isNaN(numero)) return '$0';
  
  return '$' + numero.toLocaleString('es-CL');
}


function formatearFecha(fechaStr) {
  if (!fechaStr || fechaStr === 'No disponible') return 'No disponible';
  
  try {
    const fecha = new Date(fechaStr);
    
    if (isNaN(fecha.getTime())) {
      return fechaStr;
    }
    
    return fecha.toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (e) {
    return fechaStr;
  }
}

function getEstadoClase(estado) {
  if (!estado) return 'estado-pendiente';
  
  const estadoLower = String(estado).toLowerCase();
  if (estadoLower.includes('cerrado')) {
    return 'estado-completado';
  } else if (estadoLower.includes('diagnostico') || estadoLower.includes('diagnóstico') || estadoLower.includes('proceso')) {
    return 'estado-pendiente';
  } else if (estadoLower.includes('reparado') || estadoLower.includes('completado') || estadoLower.includes('terminado')) {
    return 'estado-completado';
  } else if (estadoLower.includes('espera') || estadoLower.includes('esperando')) {
    return 'estado-espera';
  } else {
    return 'estado-pendiente';
  }
}

function actualizarProductos() {
  let categoriaValue = this.value;
  let productoSelect = document.getElementById('producto');
  
  if (!categoriaValue) {
    productoSelect.innerHTML = '<option value="">Selecciona una categoría primero</option>';
    productoSelect.disabled = true;
    document.getElementById('producto-imagen-container').classList.add('hidden');
    return;
  }
  
  productoSelect.disabled = true;
  productoSelect.innerHTML = '<option value="">Cargando productos...</option>';
  
  const productsTemplate = document.querySelector(`#product-templates div[data-collection="${categoriaValue}"]`);
  
  if (productsTemplate && productsTemplate.innerHTML.trim()) {
    productoSelect.innerHTML = '<option value="">Selecciona un producto</option>' + productsTemplate.innerHTML;
    productoSelect.disabled = false;
  } else {
    fetch(`/collections/${categoriaValue}.json`)
      .then(response => response.json())
      .then(data => {
        productoSelect.innerHTML = '<option value="">Selecciona un producto</option>';
        
        if (data.products && data.products.length > 0) {
          data.products.forEach(product => {
            const featuredImage = product.images && product.images.length > 0 
              ? product.images[0].src 
              : '/cdn/shop/products/default-product.jpg';
            
            productoSelect.innerHTML += `<option value="${product.handle}" 
                                       data-image="${featuredImage}" 
                                       data-product-id="${product.id}">
                                         ${product.title}
                                       </option>`;
          });
        } else {
          productoSelect.innerHTML += '<option value="">No hay productos disponibles</option>';
        }
        
        productoSelect.disabled = false;
      })
      .catch(error => {
        console.error('Error al cargar productos:', error);
        productoSelect.innerHTML = '<option value="">Error al cargar productos</option>';
        productoSelect.disabled = false;
      });
  }
}

function actualizarDetallesProducto() {
  const productHandle = this.value;
  const selectedOption = this.options[this.selectedIndex];
  
  if (!productHandle) {
    document.getElementById('producto-imagen-container').classList.add('hidden');
    document.getElementById('detalles-producto').classList.add('hidden');
    return;
  }
  
  const imageSrc = selectedOption.getAttribute('data-image');
  
  if (imageSrc) {
    const contenedorImagen = document.getElementById('producto-imagen-container');
    const imagen = document.getElementById('producto-imagen');
    
    contenedorImagen.classList.remove('hidden');

    const detallesDiv = document.getElementById('detalles-producto');
    detallesDiv.classList.remove('hidden');
    document.getElementById('marca-valor').innerHTML = ST_SPINNER_SM;
    document.getElementById('id-prod-valor').innerHTML = ST_SPINNER_SM;
    const marcaSelectLoad = document.getElementById('marca-select');
    marcaSelectLoad.innerHTML = '<option>Cargando...</option>';
    marcaSelectLoad.disabled = true;

    const placeholderExistente = contenedorImagen.querySelector('.imagen-placeholder');
    if (placeholderExistente) {
      placeholderExistente.remove();
    }

    imagen.style.display = 'none';

    const loadingIndicator = document.createElement('div');
    loadingIndicator.className = 'imagen-loading-indicator';
    loadingIndicator.innerHTML = `${ST_SPINNER}<span class="imagen-placeholder-text">Cargando imagen...</span>`;
    contenedorImagen.appendChild(loadingIndicator);

    const imgTemporal = new Image();
    imgTemporal.onload = function() {
      const loadingIndicator = contenedorImagen.querySelector('.imagen-loading-indicator');
      if (loadingIndicator) loadingIndicator.remove();

      imagen.style.display = '';
      imagen.src = imageSrc;
      imagen.classList.add('fade-in');
      imagenShopifyUrl = imageSrc;
      
      setTimeout(() => {
        imagen.classList.remove('fade-in');
      }, 500);
    };
    imgTemporal.onerror = function() {
      const loadingIndicator = contenedorImagen.querySelector('.imagen-loading-indicator');
      if (loadingIndicator) {
        loadingIndicator.innerHTML = `
          <div class="imagen-placeholder">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z" stroke="#bd2d34" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="imagen-placeholder-text">No se pudo cargar la imagen</span>
          </div>
        `;
      }
    };
    imgTemporal.src = imageSrc;
    
    cargarDetallesProducto(productHandle);
  } else {
    cargarDetallesProductoCompleto(productHandle);
  }
}

function actualizarMarcaSelector(vendor) {
  const select = document.getElementById('marca-select');
  const vendorOpt = vendor || 'No disponible';
  select.disabled = false;
  select.innerHTML = `
    <option value="${vendorOpt}">${vendorOpt}</option>
    <option value="__otra__">Otra marca...</option>
  `;
  select.value = vendorOpt;
  document.getElementById('marca-valor').textContent = vendorOpt;
  document.getElementById('otra-marca-container').classList.remove('marca-abierta');
  document.getElementById('marca-confirmada-row').classList.remove('marca-confirmada-visible');
  document.getElementById('otra-marca-input').value = '';
}

function inicializarMarcaUI() {
  const select        = document.getElementById('marca-select');
  const otraContainer = document.getElementById('otra-marca-container');
  const otraInput     = document.getElementById('otra-marca-input');
  const btnCancelar   = document.querySelector('.btn-marca-cancelar');
  const btnConfirmar  = document.querySelector('.btn-marca-confirmar');
  const confirmaRow   = document.getElementById('marca-confirmada-row');
  const confirmaTexto = document.getElementById('marca-confirmada-texto');
  const editarBtn     = document.getElementById('marca-editar-btn');

  select.addEventListener('change', () => {
    if (select.value === '__otra__') {
      otraContainer.classList.add('marca-abierta');
      otraInput.focus();
      btnConfirmar.disabled = true;
    } else {
      otraContainer.classList.remove('marca-abierta');
      document.getElementById('marca-valor').textContent = select.value;
    }
  });

  otraInput.addEventListener('input', () => {
    btnConfirmar.disabled = otraInput.value.trim() === '';
  });

  btnCancelar.addEventListener('click', () => {
    const vendorOpt = select.options[0].value;
    select.value = vendorOpt;
    document.getElementById('marca-valor').textContent = vendorOpt;
    otraContainer.classList.remove('marca-abierta');
    otraInput.value = '';
  });

  btnConfirmar.addEventListener('click', () => {
    const marcaPersonalizada = otraInput.value.trim();
    if (!marcaPersonalizada) return;
    document.getElementById('marca-valor').textContent = marcaPersonalizada;
    confirmaTexto.textContent = marcaPersonalizada;
    confirmaRow.classList.add('marca-confirmada-visible');
    otraContainer.classList.remove('marca-abierta');
    select.style.display = 'none';
  });

  editarBtn.addEventListener('click', () => {
    confirmaRow.classList.remove('marca-confirmada-visible');
    select.style.display = '';
    const vendorOpt = select.options[0].value;
    select.value = vendorOpt;
    document.getElementById('marca-valor').textContent = vendorOpt;
    otraInput.value = '';
  });
}

function cargarDetallesProducto(productHandle) {
  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {
      document.getElementById('id-prod-valor').textContent = product.variants[0]?.sku || 'No disponible';
      actualizarMarcaSelector(product.vendor);
      document.getElementById('detalles-producto').classList.remove('hidden');
    })
    .catch(error => {
      console.error('Error al cargar detalles del producto:', error);
      document.getElementById('id-prod-valor').textContent = 'No disponible';
      actualizarMarcaSelector('No disponible');
      document.getElementById('detalles-producto').classList.remove('hidden');
    });
}

function cargarDetallesProductoCompleto(productHandle) {
  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {
      if (product.featured_image) {
        const contenedorImagen = document.getElementById('producto-imagen-container');
        const imagen = document.getElementById('producto-imagen');
        
        contenedorImagen.classList.remove('hidden');

        const placeholderExistente = contenedorImagen.querySelector('.imagen-placeholder');
        if (placeholderExistente) placeholderExistente.remove();

        imagen.style.display = 'none';

        const loadingIndicator = document.createElement('div');
        loadingIndicator.className = 'imagen-loading-indicator';
        loadingIndicator.innerHTML = `${ST_SPINNER}<span class="imagen-placeholder-text">Cargando imagen...</span>`;
        contenedorImagen.appendChild(loadingIndicator);

        const imgTemporal = new Image();
        imgTemporal.onload = function() {
          const loadingIndicator = contenedorImagen.querySelector('.imagen-loading-indicator');
          if (loadingIndicator) loadingIndicator.remove();

          imagen.style.display = '';
          imagen.src = product.featured_image;
          imagen.classList.add('fade-in');
          imagenShopifyUrl = product.featured_image;
          
          setTimeout(() => {
            imagen.classList.remove('fade-in');
          }, 500);
        };
        imgTemporal.onerror = function() {
          const loadingIndicator = contenedorImagen.querySelector('.imagen-loading-indicator');
          if (loadingIndicator) {
            loadingIndicator.innerHTML = `
              <div class="imagen-placeholder">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z" stroke="#bd2d34" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="imagen-placeholder-text">No se pudo cargar la imagen</span>
              </div>
            `;
          }
        };
        imgTemporal.src = product.featured_image;
      } else {
        document.getElementById('producto-imagen-container').classList.add('hidden');
      }
      
      document.getElementById('id-prod-valor').textContent = product.variants[0]?.sku || 'No disponible';
      actualizarMarcaSelector(product.vendor);
      document.getElementById('detalles-producto').classList.remove('hidden');
    })
    .catch(error => {
      console.error('Error al cargar imagen del producto:', error);
      document.getElementById('producto-imagen-container').classList.add('hidden');
      document.getElementById('detalles-producto').classList.add('hidden');
    });
}

function actualizarComunas() {
  let regionValue = this.value;
  let comunaSelect = document.getElementById('comuna');
  
  if (!regionValue) {
    comunaSelect.innerHTML = '<option value="">Seleccione...</option>';
    comunaSelect.disabled = true;
    actualizarOpcionesTienda([]);
    return;
  }
  
  const regionSeleccionada = regionesChile.regiones.find(r => r.region === regionValue);
  
  if (regionSeleccionada) {
    comunaSelect.innerHTML = '<option value="">Seleccione...</option>';
    regionSeleccionada.comunas.forEach(comuna => {
      const option = document.createElement('option');
      option.value = comuna;
      option.textContent = comuna;
      comunaSelect.appendChild(option);
    });
    comunaSelect.disabled = false;
    
    actualizarOpcionesTienda(regionSeleccionada.tiendas);
  } else {
    comunaSelect.innerHTML = '<option value="">No hay comunas disponibles</option>';
    comunaSelect.disabled = true;
    actualizarOpcionesTienda([]);
  }
}

function actualizarOpcionesTienda(tiendas) {
  const tiendaContainer = document.getElementById('tiendas-entrega-container');
  
  if (!tiendaContainer) {
    console.error('No se encontró el contenedor de tiendas con ID "tiendas-entrega-container"');
    return;
  }
  
  if (tiendas && tiendas.length > 0) {
    tiendaContainer.innerHTML = `
      <div class="tienda-selector mb-3">
        <label for="tienda-entrega">Tienda para entrega presencial:</label>
        <select class="form-control" id="tienda-entrega" name="tienda-entrega">
          <option value="">Seleccione tienda...</option>
          ${tiendas.map(tienda => `<option value="${tienda.id}">${tienda.nombre} - ${tienda.direccion}</option>`).join('')}
        </select>
        <input type="hidden" id="entrega-presencial" name="entrega-presencial" value="true">
      </div>
    `;
  } else {
    tiendaContainer.innerHTML = `
      <div class="alert alert-info mensaje-despacho">
        <p><strong>Despachar a Servicio Técnico</strong></p>
        <p>Tu región no cuenta con tiendas para entrega presencial. Tu producto será enviado directamente al servicio técnico.</p>
        <input type="hidden" id="tienda-entrega" name="tienda-entrega" value="Despacho a Servicio técnico - Cordillera 101, 8730608 Ñuñoa, Región Metropolitana">
        <input type="hidden" id="entrega-presencial" name="entrega-presencial" value="true">
      </div>
    `;
  }
}

function getSelectedElements() {
  const checkboxes = document.querySelectorAll('input[name="elementos"]:checked');
  return Array.from(checkboxes).map(checkbox => checkbox.value);
}

function continuarPaso2() {
  const requiredFields = [
    { id: 'fecha-compra', name: 'Fecha de compra' },
    { id: 'categoria', name: 'Categoría' },
    { id: 'producto', name: 'Producto' },
    { id: 'numero-serie', name: 'Número de serie' },
    { id: 'sintomas', name: 'Síntomas' },
    { id: 'condicion', name: 'Condición' }
  ];
  
  for (const field of requiredFields) {
    const element = document.getElementById(field.id);
    if (!element.value.trim()) {
      alert(`Por favor complete el campo: ${field.name}`);
      element.focus();
      return;
    }
  }
  
  const fechaCompra = document.getElementById('fecha-compra').value;
  const numeroSerie = document.getElementById('numero-serie').value;
  const sintomas = document.getElementById('sintomas').value;
  const condicion = document.getElementById('condicion').value;
  
  const productoSelect = document.getElementById('producto');
  const productoOption = productoSelect.options[productoSelect.selectedIndex];
  
  paso1Data = {
    fechaCompra: fechaCompra,
    category: document.getElementById('categoria').options[document.getElementById('categoria').selectedIndex]?.text || '',
    product: productoOption?.text || '',
    productShopifyImage: imagenShopifyUrl,
    serialNumber: numeroSerie,
    elementos: getSelectedElements(),
    symptoms: sintomas,
    condition: condicion,
    marca: document.getElementById('marca-valor').textContent,
    id_prod: document.getElementById('id-prod-valor').textContent,
    tipo_cliente: "No se pudo obtener la tienda escogida"
  };
  
  document.getElementById('formulario-reparacion').classList.add('hidden');
  document.getElementById('formulario-datos-cliente').classList.remove('hidden');
}

function enviarFormulario(e) {
  e.preventDefault();
  console.log("Iniciando envío del formulario");
  
  const emailElement = document.getElementById('cliente-email');
  let emailValue = '';
  
  if (emailElement) {
    emailValue = emailElement.value.trim();
    console.log("Email capturado al inicio:", emailValue);
  } else {
    console.error("¡ALERTA! No se encontró el elemento email");
    const posiblesEmails = document.querySelectorAll('input[type="email"]');
    console.log("Campos de tipo email encontrados:", posiblesEmails.length);
    if (posiblesEmails.length > 0) {
      emailValue = posiblesEmails[0].value.trim();
      console.log("Email obtenido alternativo:", emailValue);
    }
  }
  
  if (!emailValue || !emailValue.includes('@')) {
    console.warn("Validación de email falló:", emailValue);
    alert('Por favor ingrese un email válido');
    if (emailElement) emailElement.focus();
    return;
  }
  
  const requiredFields = [
    { id: 'donde-adquirio', name: 'Donde adquirió' },
    { id: 'rut', name: 'RUT' },
    { id: 'nombre', name: 'Nombre' },
    { id: 'telefono', name: 'Teléfono' },
    { id: 'direccion', name: 'Dirección' },
    { id: 'region', name: 'Región' },
    { id: 'comuna', name: 'Comuna' },
    { id: 'numero-boleta', name: 'Número de boleta' },
    { id: 'tipo-solicitud', name: 'Tipo de solicitud' }
  ];
  
  for (const field of requiredFields) {
    const element = document.getElementById(field.id);
    if (!element || !element.value.trim()) {
      console.warn(`Campo requerido incompleto: ${field.name}`);
      alert(`Por favor complete el campo: ${field.name}`);
      if (element) element.focus();
      return;
    }
  }
  
  const compradoEn = obtenerValorCampo('donde-adquirio');
  const tipoCliente = determinarTipoCliente(compradoEn);
  paso1Data.tipo_cliente = tipoCliente;
  const rutSinFormato = obtenerValorCampo('rut');
  const rut = formatearRut(rutSinFormato);
  console.log(`RUT original: ${rutSinFormato}, RUT formateado: ${rut}`);
  
  const nombre = obtenerValorCampo('nombre');
  const telefono = obtenerValorCampo('telefono');
  const direccion = obtenerValorCampo('direccion');
  const complementoDireccion = obtenerValorCampo('complemento-direccion');
  const region = obtenerValorCampo('region');
  const comuna = obtenerValorCampo('comuna');
  const numeroBoleta = obtenerValorCampo('numero-boleta');
  const tipoSolicitud = obtenerValorCampo('tipo-solicitud');
  
  let entregaPresencial = true;
  
  let tiendaEntrega = "Despacho a Servicio técnico - Cordillera 101, 8730608 Ñuñoa, Región Metropolitana";
  const tiendaSelect = document.getElementById('tienda-entrega');
  if (tiendaSelect && tiendaSelect.value) {
    const regionSeleccionada = regionesChile.regiones.find(r => r.region === region);
    if (regionSeleccionada) {
      const tiendaSeleccionada = regionSeleccionada.tiendas.find(t => t.id === tiendaSelect.value);
      if (tiendaSeleccionada) {
        tiendaEntrega = `${tiendaSeleccionada.nombre} - ${tiendaSeleccionada.direccion}`;
      }
    }
  }
  
  const paso1DataCopy = { ...paso1Data };
  
  // Verificar que las imágenes estén disponibles
  console.log('=== VERIFICACIÓN DE IMÁGENES ===');
  console.log('Imagen Producto disponible:', imagenProductoBase64 ? `Sí (${imagenProductoBase64.length} bytes)` : 'No');
  console.log('Imagen Boleta disponible:', imagenBoletaBase64 ? `Sí (${imagenBoletaBase64.length} bytes)` : 'No');
  
  const orderData = {
    fechaCompra: paso1DataCopy.fechaCompra,
    category: paso1DataCopy.category,
    product: paso1DataCopy.product,
    productImage: imagenProductoBase64 || '',
    boletaImage: imagenBoletaBase64 || '',
    serialNumber: paso1DataCopy.serialNumber,
    elementos: paso1DataCopy.elementos,
    symptoms: paso1DataCopy.symptoms,
    condition: paso1DataCopy.condition,
    tipo_cliente: paso1DataCopy.tipo_cliente,
    marca: paso1DataCopy.marca,
    id_prod: paso1DataCopy.id_prod,
    compradoEn: compradoEn,
    rut: rut,
    nombre: nombre,
    email: emailValue,
    telefono: telefono,
    direccion: direccion,
    complementoDireccion: complementoDireccion,
    region: region,
    comuna: comuna,
    numeroBoleta: numeroBoleta,
    tipoSolicitud: tipoSolicitud,
    entregaPresencial: entregaPresencial,
    tiendaEntrega: tiendaEntrega
  };
  
  console.log("Email en orderData:", orderData.email);
  console.log("RUT en orderData:", orderData.rut);
  
  const orderDataLog = {...orderData};
  if (orderDataLog.productImage) {
    orderDataLog.productImage = `[Base64 image data - ${orderDataLog.productImage.length} bytes]`;
  }
  if (orderDataLog.boletaImage) {
    orderDataLog.boletaImage = `[Base64 image data - ${orderDataLog.boletaImage.length} bytes]`;
  }
  console.log("Datos a enviar:", JSON.stringify(orderDataLog, null, 2));
  
  const submitBtn = document.querySelector('#formulario-datos-cliente button[type="submit"]');
  const btnText = submitBtn.textContent;
  submitBtn.disabled = true;
  submitBtn.textContent = 'Enviando...';
  
  let operacionExitosa = false;
  
  saveOrder(orderData)
    .then(result => {
      operacionExitosa = true;
      console.log("Orden creada exitosamente:", result);
      mostrarModalOrden(result);
      resetearFormularios();
    })
    .catch(error => {
      if (!operacionExitosa) {
        console.error('Error al crear la orden:', error);
        alert('Error al crear la orden. Por favor intenta nuevamente.');
      }
    })
    .finally(() => {
      submitBtn.disabled = false;
      submitBtn.textContent = btnText;
    });
}

async function saveOrder(orderData) {
  if (!orderData.email || orderData.email.trim() === '') {
    console.warn('Email está vacío, intentando obtenerlo de nuevo');
    const emailField = document.getElementById('cliente-email');
    if (emailField) {
      orderData.email = emailField.value.trim();
    } else {
      const emailInputs = document.querySelectorAll('input[type="email"]');
      if (emailInputs.length > 0) {
        orderData.email = emailInputs[0].value.trim();
      }
    }
  }
  
  if (!orderData.email) {
    orderData.email = "cliente-sin-email@example.com";
  }
  
  // Separar imágenes del objeto principal
  const productImage = orderData.productImage || '';
  const boletaImage = orderData.boletaImage || '';
  
  const newOrder = {
    action: 'createOrder',
    fechaCompra: orderData.fechaCompra,
    category: orderData.category,
    product: orderData.product,
    id_prod: orderData.id_prod || 'No disponible',
    marca: orderData.marca || 'No disponible',
    serialNumber: orderData.serialNumber,
    elementos: orderData.elementos,
    symptoms: orderData.symptoms,
    condition: orderData.condition,
    tipo_cliente: orderData.tipo_cliente,
    compradoEn: orderData.compradoEn,
    rut: orderData.rut,
    nombre: orderData.nombre,
    email: orderData.email,
    telefono: orderData.telefono,
    direccion: orderData.direccion,
    complementoDireccion: orderData.complementoDireccion,
    region: orderData.region,
    comuna: orderData.comuna,
    numeroBoleta: orderData.numeroBoleta,
    tipoSolicitud: orderData.tipoSolicitud,
    entregaPresencial: orderData.entregaPresencial,
    tiendaEntrega: orderData.tiendaEntrega,
    garantia: 'Con Garantía',
    status: 'En diagnóstico',
    createdAt: new Date().toISOString()
  };
  
  console.log('=== ENVIANDO A INES ===');
  console.log('Email:', newOrder.email);
  console.log('RUT:', newOrder.rut);
  console.log('Imagen Producto a enviar:', productImage ? `${productImage.length} bytes` : 'vacía');
  console.log('Imagen Boleta a enviar:', boletaImage ? `${boletaImage.length} bytes` : 'vacía');
  
  // Agregar imágenes al objeto para que inesAPI las procese
  newOrder.productImage = productImage;
  newOrder.boletaImage = boletaImage;
  
  return inesAPI.crearOrden(newOrder);
}






// Función para obtener clase CSS según el estado
function getEstadoClase(estado) {
  if (!estado) return 'estado-pendiente';
  
  const estadoLower = String(estado).toLowerCase();
  if (estadoLower.includes('cerrado')) {
    return 'estado-completado';
  } else if (estadoLower.includes('diagnostico') || estadoLower.includes('diagnóstico') || estadoLower.includes('proceso')) {
    return 'estado-pendiente';
  } else if (estadoLower.includes('reparado') || estadoLower.includes('completado') || estadoLower.includes('terminado')) {
    return 'estado-completado';
  } else if (estadoLower.includes('espera') || estadoLower.includes('esperando')) {
    return 'estado-espera';
  } else {
    return 'estado-pendiente';
  }
}

function mostrarResultadoConsulta(order) {
  const resultadoDiv = document.getElementById('resultado-consulta');
  
  if (order.estado === "" || order.estado === null || order.estado === undefined) 
    order.estado = "Solicitud Recibida";
  else if (order.estado.includes("T�cnico") || order.estado.includes("�")) 
    order.estado = order.estado.replace(/T�cnico/g, "Técnico").replace(/t�cnico/g, "técnico").replace(/�/g, "é");
  
  if (order["Modo de Entrega"] && (order["Modo de Entrega"].includes("T�CNICO") || order["Modo de Entrega"].includes("�")))
    order["Modo de Entrega"] = order["Modo de Entrega"].replace(/T�CNICO/g, "TÉCNICO").replace(/t�cnico/g, "técnico").replace(/�/g, "é");
  
  const codigoBeca = order['Código BECA'] || order['C\u00f3digo BECA'] || '';
  let resultado = `<h5>Estado de la Orden de Reparación</h5><div class="resultado-contenido">`;
  
  const camposMostrar = [
    { clave: 'estado', etiqueta: 'Estado de la orden', clase: true },
    { clave: 'Fecha de Ingreso al SSTT', etiqueta: 'Fecha de Ingreso', formatear: true },
    { clave: 'Garantía', etiqueta: 'Garantía', clase: true },
    { clave: 'RUT', etiqueta: 'Cliente' },
    { clave: 'Familia del Producto', etiqueta: 'Categoría del producto' },
    { clave: 'Nombre del Producto', etiqueta: 'Producto' },
    { clave: 'Modelo del Producto', etiqueta: 'Modelo' },
    { clave: 'Marca del Producto', etiqueta: 'Marca' },
    { clave: 'N\u00famero de Serie del Producto', etiqueta: 'Número de serie' },
    { clave: 'Número de Serie del Producto', etiqueta: 'Número de serie' },
    { clave: 'Sucursal', etiqueta: 'Adquirido en' },
    { clave: 'Fecha de Compra', etiqueta: 'Fecha de compra' },
    { clave: 'N\u00famero de Boleta', etiqueta: 'Número de boleta' },
    { clave: 'Número de Boleta', etiqueta: 'Número de boleta' },
    { clave: 'Sintoma del Producto', etiqueta: 'Síntomas reportados', parrafo: true },
    { clave: 'Direcci\u00f3n', etiqueta: 'Dirección' },
    { clave: 'Dirección', etiqueta: 'Dirección' },
    { clave: 'Ciudad', etiqueta: 'Ciudad/Comuna' },
    { clave: 'Regi\u00f3n', etiqueta: 'Región' },
    { clave: 'Región', etiqueta: 'Región' },
    { clave: 'Modo de Entrega', etiqueta: 'Entrega' },
    { clave: 'Valor Despacho', etiqueta: 'Valor Despacho', formatearMoneda: true },
    { clave: 'Valor Reparaci\u00f3n', etiqueta: 'Valor Reparación', formatearMoneda: true },
    { clave: 'Valor Reparación', etiqueta: 'Valor Reparación', formatearMoneda: true },
    { clave: 'Estado Pago', etiqueta: 'Estado de Pago', clase: true }
  ];
  
  const camposMostrados = new Set();
  let valorReparacion = 0, valorDespacho = 0;
  
  for (const campo of camposMostrar) {
    if (order[campo.clave] && !camposMostrados.has(campo.etiqueta)) {
      let valor = decodeHTMLEntities(order[campo.clave]);
      
      if (campo.formatear) valor = formatearFecha(valor);
      
      if (campo.formatearMoneda) {
        const valorNumerico = parseFloat(valor.toString().replace(/[^\d.-]/g, ''));
        if (!isNaN(valorNumerico)) {
          if (campo.etiqueta === 'Valor Reparación') valorReparacion = valorNumerico;
          else if (campo.etiqueta === 'Valor Despacho') valorDespacho = valorNumerico;
        }
        valor = isNaN(valorNumerico) ? valor : `$${valorNumerico.toLocaleString('es-CL')}`;
      }
      
      const claseAdicional = campo.clase ? `class="${getEstadoClase(valor)}"` : '';
      const contenido = campo.parrafo ? `<p>${valor}</p>` : `<span ${claseAdicional}>${valor}</span>`;
      
      resultado += `<div class="resultado-item"><strong>${campo.etiqueta}:</strong>${contenido}</div>`;
      camposMostrados.add(campo.etiqueta);
    }
  }
  
  const procesarCampoValor = (clave, etiqueta) => {
    if (!camposMostrados.has(etiqueta) && order[clave]) {
      const valorCampo = order[clave];
      const valorNumerico = parseFloat(valorCampo.toString().replace(/[^\d.-]/g, ''));
      if (!isNaN(valorNumerico)) {
        if (etiqueta === 'Valor Reparación') valorReparacion = valorNumerico;
        else if (etiqueta === 'Valor Despacho') valorDespacho = valorNumerico;
      }
      const valorFormateado = isNaN(valorNumerico) ? valorCampo : `$${valorNumerico.toLocaleString('es-CL')}`;
      resultado += `<div class="resultado-item"><strong>${etiqueta}:</strong><span>${valorFormateado}</span></div>`;
      camposMostrados.add(etiqueta);
      return true;
    }
    return false;
  };
  
  procesarCampoValor("Valor Reparación", "Valor Reparación");
  procesarCampoValor("Valor Despacho", "Valor Despacho");
  
  if (!camposMostrados.has('Valor Reparación')) {
    const claveReparacion = Object.keys(order).find(k => 
      k.includes('Valor') && (k.includes('Reparaci') || k.includes('Reparación') || k.includes('reparaci') || k.includes('reparación')));
    if (claveReparacion && order[claveReparacion]) {
      procesarCampoValor(claveReparacion, "Valor Reparación");
    }
  }
  
  if (!camposMostrados.has('Valor Despacho')) {
    const claveDespacho = Object.keys(order).find(k => k.includes('Valor') && (k.includes('Despacho') || k.includes('despacho')));
    if (claveDespacho && order[claveDespacho]) {
      procesarCampoValor(claveDespacho, "Valor Despacho");
    }
  }
  
  const valorTotal = valorReparacion + valorDespacho;
  
  // Verificar si la orden ya está pagada
  const estaPagada = order.estado === "Pagado" || 
                     (order['Estado Pago'] && order['Estado Pago'].toLowerCase().includes('pagado'));
  
  if (valorTotal > 0 && !estaPagada) {
    // Si no está pagada, mostrar la sección de pago
    const clientEmail = obtenerClienteEmail() || '';
    resultado += `
      <div class="email-pago-container">
        <label for="email-pago" style="color: #666; font-weight: bold;">Correo electrónico para el pago:</label>
        <input type="email" id="email-pago" value="${clientEmail}" placeholder="Ingrese su correo electrónico">
      </div>
      <div style="display:flex; align-items:center; justify-content:space-between; margin:15px 0; padding:15px; border:1px solid #d0d0d0; border-radius:6px; background-color:#f5f8ff;">
        <div style="display:flex; align-items:center;">
          <strong>Valor a pagar:</strong>
          <span style="font-weight:700; color:#bd2d34; margin-left:10px;">$${valorTotal.toLocaleString('es-CL')}</span>
        </div>
        <div id="contenedor-boton-pago">
          <button type="button" class="btn-pagar" onclick="iniciarPagoFlow('${codigoBeca}', ${valorTotal}, document.getElementById('email-pago').value)">Pagar con Flow</button>
        </div>
      </div>
    `;
  } else if (valorTotal > 0 && estaPagada) {
    // Si está pagada, mostrar mensaje de pagado
    resultado += `
      <div style="margin:15px 0; padding:15px; border:1px solid #66bb6a; border-radius:6px; background-color:#e8f5e9; display:flex; align-items:center;">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:15px;">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        <div>
          <strong style="color:#2e7d32; font-size:16px;">Pago realizado correctamente</strong>
          <p style="margin:5px 0 0; color:#2e7d32;">Valor pagado: $${valorTotal.toLocaleString('es-CL')}</p>
        </div>
      </div>
    `;
  }
  
  if (order.productImage || order.imagen_producto)
    resultado += `<div class="resultado-item"><strong>Imagen del producto:</strong><div class="imagen-contenedor producto-imagen-container fade-in"><img src="${order.productImage || order.imagen_producto}" alt="Imagen del producto" style="max-height:150px;"></div></div>`;
  
  if (order.boletaImage || order.imagen_boleta)
    resultado += `<div class="resultado-item"><strong>Imagen de la boleta:</strong><div class="imagen-contenedor fade-in"><img src="${order.boletaImage || order.imagen_boleta}" alt="Imagen de la boleta" style="max-height:150px;"></div></div>`;
  
  resultado += `
    <div class="consulta-botones" style="margin-top:20px;padding-top:16px;border-top:1px solid #e0e0e0;">
      <button type="button" class="btn-volver" onclick="formularioCore.resetearFormularios()">Volver</button>
      <button type="button" class="btn-enviar" onclick="document.getElementById('btn-ingresar').click()">Ingresar Nueva Orden</button>
    </div>
  </div>`;
  
  resultadoDiv.innerHTML = resultado;
}
function determinarTipoCliente(tienda) {
  const tiendasPropias = [
  "Outlet Patio La Fábrica",
  "Outlet Patio La Florida",
  "Outlet Patio Peñuelas",
  "Outlet Arauco Premium Buenaventura",
  "Outlet Park Viña",
  "Outlet Patio Maipú",
  "Midmall",
  "Easton Outlet Mall Temuco",
  "Easton Outlet Mall Quilicura",
  "Outlet Arauco Premium San Pedro de la Paz",
  "Outlet Vivo Puente Alto",
  "Outlet Arauco La Cantera",
  "Outlet Rancagua",
  "Outlet Vivo Chillán"
];

  
  const tiendasRetail = [
    "Paris",
    "Hites",
    "Easy",
    "Jumbo",
    "Ripley",
    "Tottus",
    "Walmart",
    "Sodimac",
    "Falabella",
    "ABCDin"
  ];
  
  const tiendasEcommerce = [
    "Web Thorbenstore",
    "Mr. Click",
    "Mercado Libre",
    "Travel",
    "Bicestore",
    "BCI Ipromo",
    "Celmedia"
  ];
  
  const tiendasSinGarantia = [
    "Peixe"
  ];
  
  if (tiendasPropias.includes(tienda)) {
    return "Tiendas Propias";
  } else if (tiendasRetail.includes(tienda)) {
    return "Retail";
  } else if (tiendasEcommerce.includes(tienda)) {
    return "Ecommerce";
  } else if (tiendasSinGarantia.includes(tienda)) {
    return "Clientes sin garantía";
  } else {
    return "No se pudo obtener la tienda escogida";
  }
}